class LoginPageController {
    constructor($stateParams, $state) {
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.isReauthorizing = false;
    }

    onSignupClick() {
        this.$state.go('shop.authentication.signup', {
            toState: this.$stateParams.toState,
            toStateParams: this.$stateParams.toStateParams,
            toStateOptions: this.$stateParams.toStateOptions,
            customCallback: this.$stateParams.customCallback,
        });
    }
}

const loginPageComponentDefinition = {
    bindings: {
        authenticationMethod: '=?',
    },
    controller: ['$stateParams', '$state', LoginPageController],
    template: require('./login-page.component.html').trim(),
};

module.exports = {
    LoginPageController,
    loginPageComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/auth/login/login-page.component.js